import React, { useState,useEffect } from 'react';
import { Button } from 'react-bootstrap';
import BankAccountDatatable from './BankAccountDatatable';
import BankAccountModal from './BankAccountModal';



const BankAccountsTab = (props) => {

    
    const [show , setShow]= useState(false);
    const [entityId, setEntityId ] = useState();
    const [recordId, setRecordId ] = useState();
   
    const handleCallback = (id) => {
          setRecordId(id);       
          setShow(true);   
    };
 

    useEffect(() => {
      setEntityId(props.entityId);
    }, [props.entityId])

    const modalCallback = (isShow) => {             
      setShow(isShow);   
      //setDataChanged(dataChanged) ;         
    }

//    useEffect( () => {
  //    console.log("BankAccountDatatable state.recordId: "+recordId);   
    //  console.log("showModal: "+show);   
   // }, [recordId,show]);
  

    return (
        <div className={`tab-pane ${props.isActive ? 'active' : ''}`}>          
          <BankAccountDatatable
            
            parentCallback={handleCallback}
            entityId={entityId}
            entityName={props.entityName}                    
            modalShow={show}                    
          />
          <BankAccountModal 
            modal={show}
            parentCallback={modalCallback}
            selectedRecord={recordId}
            entityId={entityId}
            entityName={props.entityName}        
          />
          <Button
         //   bsStyle="primary"
          //  bsSize="large"
            className="ml-3 mt-3"
            onClick={() => handleCallback('')} //current => !current
          >
            <i className="fas fa-plus"></i>
          </Button>
        </div>
    );
};

export default BankAccountsTab;